export const infinityNextPageParam =
  <T extends { total: number; current_page: number }>(pageSize: number) =>
  (lastPage: T) => {
    const totalPages = Math.ceil(lastPage.total / pageSize);

    return lastPage.current_page < totalPages ? lastPage.current_page + 1 : undefined;
  };
